window.AblyTestEnvironment = document.querySelector('meta[name="runtime-environment"]').content === 'test';
